'use client';

import { useEffect } from 'react';
import { animate, type MotionValue } from 'framer-motion';
import {
  HERO_BACKGROUND_ANIMATION_COMPLETE_EVENT,
  HERO_BACKGROUND_ANIMATION_START_EVENT,
  HERO_BACKGROUND_ENTRY_DURATION_SEC,
} from './Cherobackground.constants';

interface UseCherobackgroundEntranceAnimationInput {
  delay: number;
  entranceReady: boolean;
  entryProgress: MotionValue<number>;
  onAnimationEvent?: (eventName: string) => void;
}

export function useCherobackgroundEntranceAnimation({
  delay,
  entranceReady,
  entryProgress,
  onAnimationEvent,
}: UseCherobackgroundEntranceAnimationInput): void {
  useEffect(() => {
    if (!entranceReady) {
      entryProgress.set(0);
      return;
    }

    onAnimationEvent?.(HERO_BACKGROUND_ANIMATION_START_EVENT);
    const controls = animate(entryProgress, 1, {
      duration: HERO_BACKGROUND_ENTRY_DURATION_SEC,
      ease: [0, 0.1, 0.1, 1],
      delay,
      onComplete: () => onAnimationEvent?.(HERO_BACKGROUND_ANIMATION_COMPLETE_EVENT),
    });

    return () => controls.stop();
  }, [entranceReady, delay, entryProgress, onAnimationEvent]);
}
